import api from './api';

export const getPagamentos = async (query?: string) => {
  return await api.get(`/pagamentos/`);
};
